import { render, staticRenderFns } from "./Indicado.vue?vue&type=template&id=ccbccfaa&scoped=true&lang=pug&"
import script from "./Indicado.vue?vue&type=script&lang=js&"
export * from "./Indicado.vue?vue&type=script&lang=js&"
import style0 from "./Indicado.styl?vue&type=style&index=0&id=ccbccfaa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbccfaa",
  null
  
)

export default component.exports